var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2250_134394",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00235 3.75C5.66575 3.75 5.40158 4.03864 5.43132 4.37392L5.71599 7.58288C5.729 7.72955 5.85187 7.842 5.99911 7.842C6.14614 7.842 6.2689 7.72987 6.28218 7.58345L6.57327 4.37506C6.60372 4.03938 6.3394 3.75 6.00235 3.75Z",
    fill: "#000001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56573 9.56625C5.68673 9.65975 5.83248 9.7065 6.00298 9.7065C6.16798 9.7065 6.31098 9.6625 6.43198 9.5745C6.55848 9.481 6.62173 9.316 6.62173 9.0795C6.62173 8.843 6.55848 8.68075 6.43198 8.59275C6.31098 8.50475 6.16798 8.46075 6.00298 8.46075C5.83248 8.46075 5.68673 8.50475 5.56573 8.59275C5.44473 8.68075 5.38423 8.843 5.38423 9.0795C5.38423 9.3105 5.44473 9.47275 5.56573 9.56625Z",
    fill: "#000001"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66465 1.17857C5.25854 0.107142 6.74326 0.107144 7.33715 1.17857L11.7913 9.21429C12.3852 10.2857 11.6428 11.625 10.4551 11.625H1.54673C0.358956 11.625 -0.383403 10.2857 0.210486 9.21429L4.66465 1.17857ZM6.68118 1.54217L11.1353 9.57789C11.4774 10.1949 11.0201 10.875 10.4551 10.875H1.54673C0.981708 10.875 0.524439 10.1949 0.866454 9.57789L5.32062 1.54217C5.62894 0.985943 6.37287 0.985942 6.68118 1.54217Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2250_134394)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#B10E2C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e7bf1e294b8ee6f27faef276bf5f3c7d.svg";
export { ForwardRef as ReactComponent };